<template>
    <div class="menu-item" @click="navigate">
        <div class="icon" :class="{'active': isActive}">
            <template v-if="isActive">
                <slot name="activeIcon"></slot>
            </template>
            <template v-else>
                <slot name="icon"></slot>
            </template>
        </div>
        <div class="label">
            {{ label }}
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import { RouterLink, useLink } from 'vue-router';

export default defineComponent({
    props: {
        ...RouterLink.props,
        label: {
            type: String
        }
    },
    setup: function (props) {
        const { href, isActive, isExactActive, navigate } = useLink(props)

        return { href, navigate, isActive, isExactActive }
    }
})
</script>

<style lang="scss" scoped>
.menu-item {
    @apply text-center cursor-pointer flex flex-col items-center justify-center h-18;

    .icon img {
        @apply h-8.5 w-8.5 mx-auto;
    }

    .label {
        @apply text-10 font-medium text-a-black-484848 pt-0.5;
    }
}
</style>